import moment from 'moment';

export const getSuggestionsForCurrentWeek = () => {
  const currentWeek = moment().isoWeek();
  const weekKey = String(currentWeek);

  const suggestions = defaultSuggestionsByWeek[weekKey] ?? [];
  const shuffled = [...suggestions].sort(() => Math.random() - 0.5);

  return shuffled.slice(0, 5);
};

export const defaultSuggestionsByWeek = {
  1: [
    'New Year',
    'Science',
    'Opinion',
    'Animals',
    'Social Media',
    'Geography',
    "New Year's Traditions",
    'Ancient Egypt',
    'Resolutions',
    'Goal Setting',
    'Olympics',
    'Winter',
    'Energy',
    'Video Games',
    'AI',
  ],
  2: [
    'New Year',
    'Science',
    'Snow',
    'Opinion',
    'Social Media',
    'Space',
    'Animals',
    'Winter',
    'Wildfires',
    'Olympics',
    'Technology',
    'Weather',
    'Poetry',
    'Sports',
    'Video Games',
  ],
  3: [
    'Wildfires',
    'TikTok',
    'Science',
    'Inauguration',
    'Opinion',
    'Animals',
    'Social Media',
    'Olympics',
    'Sports',
    'Poetry',
    'Space',
    'Argumentative Text',
    'Lunar New Year',
    'Technology',
    'Video Games',
    'AI',
  ],
  4: [
    'Lunar New Year',
    'Science',
    'TikTok',
    'Wildfires',
    'Inauguration',
    'Opinion',
    'Animals',
    'Chinese New Year',
    'Social Media',
    'Olympics',
    'Space',
    'Technology',
    'Video Games',
    'Argumentative Text',
    'Sports',
  ],
  5: [
    'Lunar New Year',
    'Chinese New Year',
    'Science',
    'Groundhog Day',
    'Animals',
    'Opinion',
    'Social Media',
    'Video Games',
    'Olympics',
    'Sports',
    'Wildfires',
    'Space',
    'Argumentative Text',
    'TikTok',
    "Valentine's Day",
    'Super Bowl',
    'Poetry',
    'Football',
    'AI',
  ],
  6: [
    'Super Bowl',
    "Valentine's Day",
    'Science',
    'Groundhog Day',
    'Animals',
    'Olympics',
    'Social Media',
    'Opinion',
    'Football',
    'Lunar New Year',
    'Space',
    'Video Games',
    'Technology',
    'Sports',
    'Music',
    'Weather',
  ],
  7: [
    "Valentine's Day",
    "President's Day",
    'Science',
    'Opinion',
    'Super Bowl',
    'Olympics',
    'Animals',
    'Video Games',
    'Social Media',
    'Space',
    'Poetry',
    'Geography',
    'Technology',
  ],
  8: [
    'Science',
    "President's Day",
    'Opinion',
    'Animals',
    'Social Media',
    'Video Games',
    'Poetry',
    'Space',
    'Olympics',
    'Technology',
    'Cell Phones',
    'Argumentative Text',
    'Weather',
    'Sports',
    'Geography',
    'AI',
  ],
  9: [
    'Science',
    'Opinion',
    'Animals',
    'Video Games',
    'Ramadan',
    'Olympics',
    'Sports',
    'Social Media',
    'Poetry',
    'Space',
    'Technology',
    'Weather',
    'Soccer',
    'Geography',
    'Fiction',
    'Argument',
    'Basketball',
    'Dogs',
  ],
  10: [
    "Women's History Month",
    'Science',
    'Ramadan',
    'Opinion',
    'Animals',
    'Mardi Gras',
    'Video Games',
    'Sports',
    'Social Media',
    'Poetry',
    'Olympics',
    'Fiction',
    'Space',
    "St Patrick's Day",
    'Technology',
    'Basketball',
    'Soccer',
    'Spring',
    'AI',
  ],
  11: [
    "St Patrick's Day",
    'Science',
    'Animals',
    "Women's History Month",
    'Pi Day',
    'Opinion',
    'Daylight Savings',
    'Video Games',
    'Poetry',
    'Spring',
    'Olympics',
    'Sports',
    'Space',
    'Social Media',
    'March Madness',
    'Soccer',
    'Lunar Eclipse',
  ],
  12: [
    "St Patrick's Day",
    'Spring',
    'Science',
    'March Madness',
    'Animals',
    'Opinion',
    'Olympics',
    'Space',
    'Video Games',
    'Social Media',
    "Women's History Month",
    'Sports',
    'Poetry',
    'Weather',
    'Basketball',
    'Spring Break',
  ],
  13: [
    'Science',
    'Spring',
    'Poetry',
    'Animals',
    'Opinion',
    'Sports',
    'March Madness',
    'Social Media',
    'Cesar Chavez',
    'Video Games',
    'Olympics',
    'Space',
    'Basketball',
    'Soccer',
    'Weather',
    "Women's History Month",
    'Fiction',
    "April Fool's Day",
    'Cell Phones',
    'Music',
    'Technology',
    'AI',
  ],
  14: [
    "April Fool's Day",
    'Science',
    'Poetry',
    'Spring',
    'Animals',
    'Earth Day',
    'Opinion',
    'Sports',
    'Video Games',
    'Space',
    'Olympics',
    'Social Media',
    'Cesar Chavez',
    'Easter',
    'Geography',
    'Soccer',
    'Basketball',
    'Weather',
  ],
  15: [
    'Science',
    'Earth Day',
    'Poetry',
    'Easter',
    'Animals',
    'Spring',
    'Opinion',
    'Sports',
    'Olympics',
    'Video Games',
    'Space',
    'Social Media',
    'Weather',
    'Cold War',
    'Tariffs',
    'Geography',
    'Technology',
    'Soccer',
    'Basketball',
    'AI',
  ],
  16: [
    'Earth Day',
    'Easter',
    'Science',
    'Poetry',
    'Animals',
    'Titanic',
    'Opinion',
    'Space',
    'Video Games',
    'Spring',
    'Sports',
    'Olympics',
    'Social Media',
    'Soccer',
    'Weather',
    'Minecraft',
    'Cold War',
    'Tariffs',
    'Geography',
  ],
  17: [
    'Earth Day',
    'Science',
    'Poetry',
    'Animals',
    'Video Games',
    'Opinion',
    'Sports',
    'Social Media',
    'Olympics',
    'Space',
    'Spring',
    'Cold War',
    'Geography',
    'Soccer',
    'Minecraft',
    'AI',
  ],
  18: [
    'Cinco De Mayo',
    'Science',
    'Animals',
    'Poetry',
    'May Day',
    'Olympics',
    'Opinion',
    'Sports',
    'Space',
    'Earth Day',
    'Cold War',
    'Video Games',
    'Soccer',
    'Geography',
    'Summer',
    'Social Media',
    'World War 2',
    'Weather',
    'Music',
  ],
  19: [
    'Cinco De Mayo',
    'Science',
    "Mother's Day",
    'Animals',
    'Summer',
    'Space',
    'Video Games',
    'Soccer',
    'Sports',
    'Cold War',
    'Poetry',
    'Opinion',
    'Olympics',
    'Geography',
    'Food',
  ],
  20: [
    'Science',
    'Summer',
    'Memorial Day',
    'Animals',
    'Sports',
    'Video Games',
    'Poetry',
    'Olympics',
    'Space',
    'Opinion',
    'Geography',
    'Soccer',
    'Cold War',
    'Greek Mythology',
    'Music',
    'Vietnam War',
    'World War 2',
    'Minecraft',
    'Current Events',
    'Social Media',
    'AI',
  ],
  21: [
    'Memorial Day',
    'Summer',
    'Science',
    'Animals',
    'Sports',
    'Video Games',
    'Poetry',
    'Space',
    'Opinion',
    'Olympics',
    'Geography',
    'Soccer',
    'Minecraft',
    'Weather',
    'Vietnam War',
    'Cold War',
    'Social Media',
    'Ancient Rome',
    'Greek Mythology',
  ],
  22: [
    'Memorial Day',
    'Summer',
    'Science',
    'Sports',
    'Animals',
    'Space',
    'Olympics',
    'Basketball',
    'Social Media',
    'Soccer',
    'Ancient Greece',
    'Geography',
    'Video Games',
    'Dogs',
    'Fiction',
    'Minecraft',
    'Poetry',
    'Ancient Rome',
    'AI',
  ],
  23: [
    'Summer',
    'Science',
    'Animals',
    'Olympics',
    'Sports',
    'Space',
    'Opinion',
    'Video Games',
    'Geography',
    'Soccer',
    'Basketball',
    'Ancient Rome',
    'Social Media',
    'Back To School',
    'Health',
    'Artificial Intelligence',
  ],
  24: [
    'Summer',
    'Science',
    'Olympics',
    'Animals',
    'Sports',
    'Video Games',
    'Space',
    'Back To School',
    'Flag Day',
    'Geography',
    'Technology',
    'Soccer',
    'AI',
    'Labubu',
    'Poetry',
    'Basketball',
    'Ancient Rome',
  ],
  25: [
    'Summer',
    'Science',
    'Sports',
    'Animals',
    'Olympics',
    'Soccer',
    'Back To School',
    'Graphic Organizers',
    'Geography',
    'Video Games',
    'Opinion',
    'Dogs',
    'Space',
    'Baseball',
    'AI',
    'Ancient Rome',
    'History',
  ],
  26: [
    'Summer',
    'Science',
    'Animals',
    'Soccer',
    'Sports',
    'Video Games',
    'Olympics',
    'Back To School',
    'Space',
    'Geography',
    'Poetry',
    'Social Media',
    'AI',
    '4th Of July',
    'Energy',
    'Basketball',
    'What Is Energy',
    'Iran',
    'Football',
  ],
  27: [
    'Science',
    'Fourth Of July',
    'Soccer',
    'Independence Day',
    'Summer',
    'Back To School',
    'Sports',
    'Animals',
    'Geography',
    'Video Games',
    'Social Media',
    'Olympics',
    'Basketball',
    'Greek Mythology',
    'Math',
    'Food',
    'AI',
    'Technology',
    'Dogs',
  ],
  28: [
    'Animals',
    'Science',
    'Olympics',
    'Back To School',
    'Sports',
    'Soccer',
    'Space',
    'Summer',
    'Dogs',
    'Geography',
    'Video Games',
    'Football',
    'Roblox',
    'Basketball',
    'Social Media',
    'Music',
    'Opinion',
    'Sharks',
    'Fiction',
    'Weather',
    'Capybara',
  ],
  29: [
    'Back To School',
    'Science',
    'Animals',
    'Olympics',
    'Sports',
    'Summer',
    'Soccer',
    'Minecraft',
    'Video Games',
    'Geography',
    'Social Media',
    'AI',
    'Fiction',
    'Dogs',
    'Ancient Egypt',
    'Weather',
    'Capybara',
    'Football',
    'Sharks',
    'Space',
  ],
  30: [
    'Back To School',
    'Animals',
    'Soccer',
    'Science',
    'Olympics',
    'Sports',
    'Summer',
    'Geography',
    'Math',
    'Football',
    'Poetry',
    'Minecraft',
    'Dogs',
    'Opinion',
    'AI',
    'Space',
    'History',
    'Video Games',
    'Fiction',
    'Sharks',
    'Capybara',
  ],
  31: [
    'Back To School',
    'Geography',
    'Olympics',
    'Maps',
    'Science',
    'Technology',
    'Math',
    'Sports',
    'Soccer',
    'Animals',
    'AI',
    'Landforms',
    'Fiction',
    'Summer',
    'Scientific Method',
    'Dogs',
    'Space',
    'Labubu',
    'Football',
    'Labor Day',
    'Greek Mythology',
  ],
  32: [
    'Back To School',
    'Geography',
    'Olympics',
    'Science',
    'Maps',
    'Graphic Organizers',
    'Scientific Method',
    'Sports',
    '5 Themes Of Geography',
    'Culture',
    'Technology',
    'Math',
    'AI',
    'Matter',
    'Community',
    'Animals',
    'Economics',
    'Mesopotamia',
    'Poetry',
    'Current Events',
  ],
  33: [
    'Back To School',
    'Science',
    'Geography',
    'Olympics',
    'Scientific Method',
    'Culture',
    'AI',
    'Sports',
    'Math',
    'Animals',
    'Fiction',
    'First Day Of School',
    'Matter',
    'Current Events',
    'Soccer',
    'Music',
    'Labubu',
    'Maps',
    'School',
    '5 Themes Of Geography',
    'Cells',
  ],
  34: [
    'Back To School',
    'Science',
    'Geography',
    'Scientific Method',
    'Olympics',
    'Math',
    'Animals',
    'Sports',
    'AI',
    'Culture',
    'Buddy Benches',
    'Theme',
    'Fiction',
    'Matter',
    'Labor Day',
    'Video Games',
    'Maps',
    'Music',
    'Empathy',
    'Current Events',
    'Cell Phones',
  ],
  35: [
    'Back To School',
    'Olympics',
    'Geography',
    'Labor Day',
    '9/11',
    'Animals',
    'Science',
    'Energy',
    'Scientific Method',
    'Math',
    'Space',
    'Ecosystems',
    'Fiction',
    'Refugee',
    'Health',
    'First Day Of School',
    'Water Cycle',
    'Point Of View',
    'Cars',
    'Mesopotamia',
    'Back To School',
    'Labor Day',
    'Science',
    'Geography',
    'Scientific Method',
    'Olympics',
    'AI',
    '9/11',
    'Empathy',
    'Fiction',
    'Video Games',
    'Music',
    'Maps',
    'Culture',
    'Animals',
    'Sports',
    'Technology',
    'Soccer',
    'Current Events',
    'Dogs',
    'Theme',
  ],
  36: [
    '9/11',
    'Olympics',
    'Back To School',
    'Science',
    'Geography',
    'Labor Day',
    'Animals',
    'Sports',
    'Matter',
    'Video Games',
    'Cell Phones',
    'Soccer',
    'Election',
    'Fiction',
    'National Hispanic Heritage Month',
    'Football',
    'Scientific Method',
    'Culture',
    'Technology',
  ],
  37: [
    'Olympics',
    'Science',
    'Back To School',
    'History Of 9/11',
    'Geography',
    'Friday the 13th',
    'Animals',
    'Sports',
    'Election',
    'Video Games',
    'Fiction',
    'Debate',
    'National Hispanic Heritage Month',
    'Football',
    'Patriot Day',
  ],
  38: [
    'Science',
    'Olympics',
    'National Hispanic Heritage Month',
    'Geography',
    'Constitution Day',
    'Back To School',
    'Animals',
    'Video Games',
    'Sports',
    'Hispanic',
    'Soccer',
    'Election',
    'Fiction',
    'Fall',
    'Matter',
    'Mesopotamia',
    'Music',
    'Scientific Method',
    'Mexican Independence Day',
    'Poetry',
  ],
  39: [
    'Science',
    'Olympics',
    'Geography',
    'National Hispanic Heritage Month',
    'Halloween',
    'Animals',
    'Fall',
    'Back To School',
    'Election',
    'Sports',
    'Video Games',
    'Fiction',
    'Hurricane',
    'Theme',
    'Soccer',
    'Music',
    'Mesopotamia',
    'Ancient Egypt',
    'Matter',
    'Space',
    'Opinion',
  ],
  40: [
    'Halloween',
    'Science',
    'Hurricane',
    'Olympics',
    'Geography',
    'Fall',
    'Election',
    'Animals',
    'Rosh Hashanah',
    'Soccer',
    'Video Games',
    'Sports',
    'Fiction',
    'Back To School',
    'Poetry',
    'Space',
    'National Hispanic Heritage Month',
    'Mesopotamia',
    'Football',
    'Theme',
  ],
  41: [
    'Halloween',
    'Science',
    'Election',
    'Olympics',
    'Animals',
    'Geography',
    'Indigenous',
    'Mesopotamia',
    'Sports',
    'Video Games',
    'Voting',
    'Christopher Columbus',
    'Opinion',
    'Electoral College',
    'Theme',
  ],
  42: [
    'Halloween',
    'Science',
    'Election',
    'Hurricane',
    'Animals',
    'Olympics',
    'Geography',
    'Columbus Day',
    'Day Of The Dead',
    'Voting',
    'Electoral College',
    'Sports',
    'Dia De Los Muertos',
    'Mesopotamia',
    'Opinion',
    'Fall',
    'Theme',
    'Space',
  ],
  43: [
    'Halloween',
    'Election',
    'Science',
    'Day Of The Dead',
    'Electoral College',
    'Dia De Los Muertos',
    'Voting',
    'Olympics',
    'Animals',
    'History Of Halloween',
    'Geography',

    'Sports',
    'Poetry',
    'Hurricane',
    'Fall',
    'Mesopotamia',
    'Opinion',
    'Diwali',
    'Video Games',
    'Ancient Egypt',
  ],
  44: [
    'Halloween',
    'Election',
    'Day Of The Dead',
    'Dia De Los Muertos',
    'Voting',
    'History Of Halloween',
    'Electoral College',
    'Diwali',
    'Science',
    'Thanksgiving',
    "Veteran's Day",
    'Election Day',
    'Halloween Candy',
    'Olympics',
    'Animals',
    'Geography',
    'Poetry',
    'Sports',
    'Opinion',
  ],
  45: [
    'Election',
    "Veteran's Day",
    'Thanksgiving',
    'Voting',
    'Election Day',
    'Electoral College',
    'Science',
    'Animals',
    'Olympics',
    'Veterans',
    'Opinion',
    'Poetry',
    'Geography',
    'Video Games',
    'Sports',
    'Soccer',
    'Social Media',
  ],
  46: [
    'Thanksgiving',
    "Veteran's Day",
    'Science',
    'Animals',
    'Olympics',
    'Opinion',
    'Sports',
    'Video Games',
    'Veterans',
    'Social Media',
    'Ancient Egypt',
    'Geography',
    'Poetry',
    'Space',
    'Soccer',
  ],
  47: [
    'Thanksgiving',
    'Science',
    'First Thanksgiving',
    'Christmas',
    'Animals',
    'Olympics',
    'Thanksgiving',
    'Video Games',
    'Ancient Egypt',
    'Opinion',
    'Space',
    'Sports',
    'Gratitude',
    'Soccer',
    'Geography',
    'Poetry',
    'Weather',
    'Social Media',
  ],
  48: [
    'Thanksgiving',
    'Christmas',
    'First Thanksgiving',
    'Science',
    'Social Media',
    'Winter',
    'Gratitude',
    'Olympics',
    'Animals',
    'Black Friday',
    'Opinion',
    'Holidays',
    'Geography',
    'Sports',
    'History Of Thanksgiving',
    'Space',
    'Ancient Egypt',
  ],
  49: [
    'Christmas',
    'Winter',
    'Science',
    'Holidays',
    'Social Media',
    'Pearl Harbor',
    'Animals',
    'Holidays Around The World',
    'Opinion',
    'Sports',
    'Video Games',
    'Olympics',
    'Ancient Egypt',
    'Weather',
    'Poetry',
    'December',
    'Space',
    'Geography',
    'Soccer',
  ],
  50: [
    'Christmas',
    'Winter',
    'Holidays',
    'Science',
    'Holidays Around The World',
    'Winter Holidays',
    'Animals',
    'Opinion',
    'Hanukkah',
    'Social Media',
    'Poetry',
    'Winter Solstice',
    'Sports',
    'Ancient Egypt',
    'Video Games',
    'Space',
    'Kwanzaa',
    'History Of Christmas',
    'Geography',
  ],
  51: [
    'Christmas',
    'Holidays',
    'Winter',
    'Science',
    'New Years',
    'Winter Holidays',
    'Holidays Around The World',
    'Winter Solstice',
    'History Of Christmas',
    'Hanukkah',
    'Kwanzaa',
    'Animals',
    'Sports',
    'Opinion',
    'Olympics',
    'Video Games',
    'Social Media',
    'Ancient Egypt',
    'Poetry',
    'Geography',
    'Space',
  ],
  52: [
    'New Year',
    'Christmas',
    'Olympics',
    'Science',
    "New Year's Resolutions",
    'Soccer',
    'Back To School',
    'Basketball',
    'Weather',
    'Space',
    'Fiction',
    'Friendship',
    'Technology',
    'Ancient Civilizations',
    'Music',
  ],
  53: [
    'New Year',
    'Christmas',
    'Olympics',
    'Science',
    "New Year's Resolutions",
    'Soccer',
    'Back To School',
    'Basketball',
    'Weather',
    'Space',
    'Fiction',
    'Friendship',
    'Technology',
    'Ancient Civilizations',
    'Music',
  ],
};
